import React from 'react';
import { capitalize } from '../../../../assets/helpers/funciones';

/**
 * Formatea una cadena "padre / hijo" para mostrar cada segmento capitalizado.
 */
export const formatBelongsToHierarchy = (str) => {
  if (!str || typeof str !== 'string') return '';
  return str
    .split('/')
    .map((part) => capitalize(part.trim()))
    .join(' / ');
};

/**
 * Celda de tabla: estado Activo / Inactivo (pastillas).
 */
export const TableCellActiveStatus = ({
  isActive,
  activeLabel = 'Activo',
  inactiveLabel = 'Inactivo',
}) => (
  <td>
    <span
      className={
        isActive
          ? 'table-cell__status table-cell__status--active'
          : 'table-cell__status table-cell__status--inactive'
      }
    >
      {isActive ? activeLabel : inactiveLabel}
    </span>
  </td>
);

/**
 * Celda de tabla: estado Activo / Inactivo (pastillas).
 */
export const TableCellActiveStatusCampaign = ({
  isActive,
}) => (
  <td>
    <span
      className={
        isActive === 'activa' || isActive === 'espera'
          ? 'table-cell__status table-cell__status--active'
          : 'table-cell__status table-cell__status--inactive'
      }
    >
      {capitalize(isActive)}
    </span>
  </td>
);

export const TableCellActiveStatusDiscount = ({
  isActive,
  label = '',
}) => (
  <td>
    <span
      className={
        isActive
          ? 'table-cell__status table-cell__status--active'
          : 'table-cell__status table-cell__status--inactive'
      }
    >
      {label}
    </span>
  </td>
);

/**
 * Celda de tabla: acción Activar / Inactivar.
 */
export const TableCellActivateToggle = ({
  row,
  isActive,
  onToggle,
  activateLabel = 'Activar',
  deactivateLabel = 'Inactivar',
}) => (
  <td>
    {typeof onToggle === 'function' && (
      <button
        type="button"
        className={
          isActive
            ? 'table-cell__toggle-action table-cell__toggle-action--deactivate'
            : 'table-cell__toggle-action table-cell__toggle-action--activate'
        }
        onClick={() => onToggle(row)}
      >
        {isActive ? deactivateLabel : activateLabel}
      </button>
    )}
  </td>
);

/**
 * Celda de tabla: contador de registros hijos (badge gris).
 */
export const TableCellChildRecordsBadge = ({ count, childLabel }) => (
  <td>
    <span className="table-cell__child-badge">
      {count ?? 0} {childLabel}
    </span>
  </td>
);

/**
 * Celda: clase de vehículo (etiqueta de color; variant controla el tema desde el padre).
 */
export const TableCellVehicularClassBadge = ({
  label,
  variant = 'default',
}) => (
  <td>
    <span
      className={`table-cell__class-tag table-cell__class-tag--${variant}`}
    >
      {label ? capitalize(label) : '—'}
    </span>
  </td>
);

/**
 * Celda: clase de vehículo (etiqueta de color; variant controla el tema desde el padre).
 */
export const TableSalesChannelLinksClassBadge = ({
  label,
  variant = 'default',
  link = null
}) => (
    
      link ? (
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          className={`table-cell__class-tag table-cell__class-tag--${variant}`}
          style={{ textDecoration: 'none' }}
        >
          {label ?? ''}
        </a>
      ) : (
        <span
          className={`table-cell__class-tag table-cell__class-tag--${variant}`}
        >
          {label ? capitalize(label) : '—'}
        </span>
      )
    
);

/**
 * Celda de tabla: ícono de estado (check verde para activo, equis roja para inactivo).
 */
export const TableCellStatusIcon = ({ isActive }) => (
  <td style={{ textAlign: 'center' }}>
    <span
      className={
        isActive
          ? 'table-cell__status-icon table-cell__status-icon--active'
          : 'table-cell__status-icon table-cell__status-icon--inactive'
      }
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        backgroundColor: isActive ? '#DFF6E3' : '#FDE7E7',
        width: 48,
        height: 48,
      }}
    >
      {isActive ? (
        // Checkmark SVG
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <circle cx="16" cy="16" r="16" fill="none"/>
          <path d="M10 17L15 22L22 13" stroke="#34C759" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ) : (
        // X SVG
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <circle cx="16" cy="16" r="16" fill="none"/>
          <path d="M11 11L21 21M21 11L11 21" stroke="#FF3B30" strokeWidth="3" strokeLinecap="round"/>
        </svg>
      )}
    </span>
  </td>
);